import jwtDecode from 'jwt-decode';

export const jwtDecoder = (token: string): any => {
  try {
    return jwtDecode(token);
  } catch (Error) {
    return null;
  }
};
